import { Component, OnInit } from '@angular/core';
import { AdminComponent } from '../admin/admin.component';
import { Router, ActivatedRoute } from '@angular/router';
import * as $ from 'jquery';
import { DataPassingService } from '../service/data-passing.service';
import { isEmpty } from 'rxjs/operators';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  // ...
} from '@angular/animations';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css'],
  providers:[AdminComponent],
  animations: [
    trigger('openClose', [
      // ...
      state('open', style({
        height: '200px',
        opacity: 1,
      })),
      state('closed', style({
        height: '200px',
        opacity: 0,
      })),
      transition('open => closed', [
        animate('1s')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ]),
    ]),
  ]
})
export class NavComponent implements OnInit {
  menus:object[]=[];
  dueInfo=0;
  isOpen = false;
  constructor(private route:ActivatedRoute,private dataPass:DataPassingService) { 
    
  }

  ngOnInit() {
    this.dataPass.passDataService({});
    this.route.data.subscribe(data=>{
    
     data.menuList[0].data.forEach(element => {
       
       var submenu=(element.subMenu.length)?element.subMenu:null;
       let mUrl=(element.pageLink)?element.pageLink:"#";
       //var subUrl=(element.sub_links)?element.sub_links.split(","):null;
       var menu={main_menu:element.menuName,mUrl:mUrl,submenu:submenu,badge:true};
      this.menus.push(menu);
     });

     
    },(error)=>{
     
    });

    

    

  }

  

}
